import { createUserSelectors } from '@make-software/tg-mini-app-ui';

import { UserState } from './slice';

export const { selectUser, selectUserLoading, selectUserError } = createUserSelectors(
  (state: { user: UserState }) => state.user
);

export const selectUserPoints = (state: { user: UserState }) =>
  state.user.data?.balance.find((b) => b.unit === 'points')?.balance || 0;

export const selectUserWallet = (state: { user: UserState }) => state.user.data?.wallet;
